import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AdminListVpsByUserComponent from "../../../components/Admin/users/AdminListVpsByUserComponent";

const ListVpsByUserPage = () => {
    const params = useParams()
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/admin/khach-hang');
    }

    return <AdminListVpsByUserComponent
        userId={ params.userId }
        shouldRedirect={ () => redirect() }
    />;
}

export default ListVpsByUserPage;